/* eslint-disable formatjs/no-literal-string-in-jsx */
/* eslint-disable react/jsx-no-literals */
import { sharedDeviceMessage } from '../vonage/device_settings/messages';

function localeMessage(id, locale = 'en', values = {}) {
  const shared = sharedDeviceMessage(id, locale, values);
  if (shared !== undefined) return shared;
  const found = messages.find(message => message.id === id);

  if (!found) {
    return '';
  }

  const value = found[locale] || found.en;
  if (typeof value !== 'string') return value;
  return Object.keys(values).reduce(
    (message, key) => message.replace(`{{${key}}}`, values[key]),
    value,
  );
}

const messages = [
  {
    id: 'tellUsMore',
    en: 'Tell us more about your experience',
    fr: 'Parlez-nous de votre expérience',
  },
  {
    id: 'yourCare',
    en: (
      <span className="client-waiting-message">
        The person you are waiting for will arrive soon. If you don&apos;t see
        them and it is after the scheduled appointment start time, message them
        directly in the chat box. For more information,{' '}
        <a href="https://inkblot.zendesk.com/hc/en-us/articles/360053062011-Troubleshooting-Cannot-connect-to-my-appointment">
          visit the Help Centre
        </a>
      </span>
    ),
    fr: (
      <span className="client-waiting-message">
        La personne que vous attendez arrivera bientôt. Si vous ne la voyez pas
        et l&apos;heure de début de votre séance est dépassée, envoyez-lui un
        message directement dans la boîte de dialogue. Pour plus
        d&apos;informations,{' '}
        <a href="https://inkblot.zendesk.com/hc/fr-ca/articles/360053062011-Troubleshooting-Cannot-connect-to-my-appointment">
          visitez le Centre d&apos;aide
        </a>
      </span>
    ),
  },
  {
    id: 'yourPartner',
    en: 'Your partner will arrive soon.',
    fr: 'Votre partenaire va bientôt arriver.',
  },
  {
    id: 'yourPartnerIssue',
    en: 'It appears that your partner either has their camera or microphone off, or is having some hardware issues. ',
    fr: 'Il semble que la caméra ou le microphone de votre partenaire soit désactivé, ou qu’il éprouve des problèmes techniques.',
  },
  {
    id: 'yourProviderIssue',
    en: 'It appears that your care provider has their camera or microphone off, or may be having some hardware issues. ',
    fr: 'Il semble que la caméra ou le microphone de votre prestataire de soins soit désactivé, ou qu’il éprouve des problèmes techniques.',
  },
  {
    id: 'uniqueDialInCode',
    en: 'You can choose to use your unique dial in code to connect by voice: ',
    fr: 'Vous pouvez choisir d’utiliser votre code d’accès unique pour vous connecter par téléphone : ',
  },
  {
    id: 'contactSupport',
    en: ' or contact support.',
    fr: ' ou de communiquer avec le soutien.',
  },
  {
    id: 'unableTo',
    en: 'Unable to connect? Please refresh your page ',
    fr: 'Vous avez des difficultés à vous connecter? ',
  },
  {
    id: 'here',
    en: 'here',
    fr: 'Cliquez ici',
  },
  {
    id: 'Chat',
    en: 'Chat',
    fr: 'Clavardage',
  },
  {
    id: 'Notes',
    en: 'Notes',
    fr: 'Notes',
  },
  {
    id: 'Audio Difficulties',
    en: 'Audio Difficulties',
    fr: 'Difficultés avec l’audio',
  },
  {
    id: 'forAudio',
    en: 'For audio difficulties, please call ',
    fr: 'En cas de difficulté avec l’audio, veuillez contacter ',
  },
  {
    id: 'withPin',
    en: ' with pin ',
    fr: ' avec le NIP ',
  },
  {
    id: 'completeSession',
    en: 'Complete Session',
    fr: 'Terminez la session',
  },
  {
    id: 'reconnect',
    en: 'Reconnect',
    fr: 'Se connecter à nouveau',
  },
  {
    id: 'hideTime',
    en: 'Hide Time',
    fr: 'Masquez l’heure',
  },
  {
    id: 'showTime',
    en: 'Show time',
    fr: 'Afficher le temps',
  },
  {
    id: 'careProvider',
    en: 'Care Provider',
    fr: 'Conseiller',
  },
  {
    id: 'partner',
    en: 'Partner',
    fr: 'Partenaire',
  },
  {
    id: 'hasExpired',
    en: 'This session has expired',
    fr: 'Cette session est expirée',
  },
  {
    id: 'typeMessage',
    en: 'Type a message',
    fr: 'Veuillez taper un message',
  },
  {
    id: 'rateSession',
    en: 'How would you rate the session?',
    fr: 'Comment évaluez-vous la session?',
  },
  {
    id: 'successful',
    en: 'Successful: ',
    fr: 'Avec succès : ',
  },
  {
    id: 'noIssues',
    en: 'my session had no issues',
    fr: 'sans difficulté',
  },
  {
    id: 'unsuccessful',
    en: 'Unsuccessful: ',
    fr: 'Infructueuse : ',
  },
  {
    id: 'chooseReason',
    en: 'please choose a reason why',
    fr: 'sélectionnez une raison',
  },
  {
    id: 'technicalIssues',
    en: 'Technical issues',
    fr: 'Difficultés techniques',
  },
  {
    id: 'forMe',
    en: 'Counselling isn’t for me',
    fr: 'Le counselling n’est pas pour moi',
  },
  {
    id: 'notConnect',
    en: 'I didn’t connect with my care provider',
    fr: 'Ça n’a pas cliqué avec mon conseiller',
  },
  {
    id: 'notShow',
    en: 'My care provider was very late/didn’t show up',
    fr: 'Mon conseiller était en retard / ne s’est pas présenté',
  },
  {
    id: 'wasUnprofessional',
    en: 'My care provider was unprofessional',
    fr: 'Mon conseiller était peu professionnel',
  },
  {
    id: 'other',
    en: 'Other',
    fr: 'Autre',
  },
  {
    id: 'toComplete',
    en: 'Are you sure you want to complete the session?',
    fr: 'Êtes-vous certain de vouloir terminer la session?',
  },
  {
    id: 'yes',
    en: 'Yes',
    fr: 'Oui',
  },
  {
    id: 'no',
    en: 'No',
    fr: 'Non',
  },
  {
    id: 'partnerRoom',
    en: 'Are you and your partner in the same room?',
    fr: 'Est-ce vous et votre partenaire êtes dans la même pièce?',
  },
  {
    id: 'sameRoom',
    en: 'Yes, We are in the same room.',
    fr: 'Oui, nous sommes dans la même pièce.',
  },
  {
    id: 'joiningSeparately',
    en: 'No, We are joining separately.',
    fr: 'Non, nous joignons de façon séparée.',
  },
  {
    id: 'NotAllowedError',
    en: 'Your browser is not permitting access to your camera/microphone, please refresh after fixing.',
    fr: 'Votre navigateur n’autorise pas l’accès à votre caméra/microphone, veuillez actualiser après avoir apporté les modifications nécessaires.',
  },
  {
    id: 'NotFoundError',
    en: 'Unable to detect a camera/microphone, please refresh after fixing.',
    fr: 'Impossible de détecter une caméra/un microphone, veuillez actualiser après avoir apporté les modifications nécessaires.',
  },
  {
    id: 'NotReadableError',
    en: 'A hardware issue has occurred with your camera/microphone, please refresh after fixing.',
    fr: 'Un problème matériel s’est produit avec votre caméra/microphone, veuillez actualiser après avoir apporté les modifications nécessaires.',
  },
  {
    id: 'UnknownError',
    en: 'Unknown Error',
    fr: 'Erreur inconnue',
  },
  {
    id: 'connectionError',
    en: 'We were unable to connect you to the session. Please refresh the page to try again.',
    fr: 'Nous n’avons pas pu vous connecter à la séance. Veuillez rafraîchir la page pour réessayer.',
  },
  {
    id: 'youAreNowConnected',
    en: 'You are now connected',
    fr: 'Vous êtes maintenant connecté.',
  },
  {
    id: 'successfulSession',
    en: 'Successful: my session had no issues',
    fr: "Succès : ma séance s'est déroulée sans problème.",
  },
  {
    id: 'reconnecting',
    en: 'Reconnecting…',
    fr: 'Reconnexion en cours…',
  },
  {
    id: 'connectionLost',
    en: 'You have been disconnected. Please refresh the page to rejoin.',
    fr: 'Vous avez été déconnecté(e). Veuillez rafraîchir la page pour vous reconnecter.',
  },
  {
    id: 'requiredError',
    en: 'Required',
    fr: 'Obligatoire',
  },
  {
    id: 'preCall.close',
    en: 'Close',
    fr: 'Fermer',
  },
  {
    id: 'preCall.permission.title',
    en: "Let's check your session settings",
    fr: 'Vérifions les paramètres de votre séance',
  },
  {
    id: 'preCall.permission.description',
    en: 'Your browser will ask for camera and microphone access. You need to allow both before joining your session.',
    fr: 'Votre navigateur demandera l’accès à votre caméra et à votre microphone. Vous devez autoriser les deux avant de rejoindre votre séance.',
  },
  {
    id: 'preCall.permission.microphone.title',
    en: 'Allow microphone',
    fr: 'Autoriser le microphone',
  },
  {
    id: 'preCall.permission.microphone.description',
    en: 'So your care provider can hear you',
    fr: 'Pour que votre prestataire de soins puisse vous entendre',
  },
  {
    id: 'preCall.permission.camera.title',
    en: 'Allow camera',
    fr: 'Autoriser la caméra',
  },
  {
    id: 'preCall.permission.camera.description',
    en: 'So your care provider can see you',
    fr: 'Pour que votre prestataire de soins puisse vous voir',
  },
  {
    id: 'preCall.permission.continue',
    en: 'Continue',
    fr: 'Continuer',
  },
  {
    id: 'preCall.microphoneRequired.title',
    en: 'Microphone required to join',
    fr: 'Un microphone est requis pour participer',
  },
  {
    id: 'preCall.microphoneRequired.description',
    en: "You can't join your appointment until microphone access is enabled in your browser settings. You might see a pop-up notification or an icon in your address bar asking you to allow access.",
    fr: 'Vous ne pouvez pas rejoindre votre rendez-vous tant que l’accès au microphone n’est pas activé dans les paramètres de votre navigateur.',
  },
  {
    id: 'preCall.microphoneRequired.camera',
    en: 'Camera access is optional but recommended. You can turn it on or off at any time during your session.',
    fr: 'L’accès à la caméra est facultatif, mais recommandé. Vous pouvez l’activer ou la désactiver à tout moment pendant votre séance.',
  },
  {
    id: 'preCall.microphoneRequired.close',
    en: 'Close',
    fr: 'Fermer',
  },
  {
    id: 'preCall.title',
    en: 'You are about to start your session',
    fr: 'Vous êtes sur le point de commencer votre séance',
  },
  {
    id: 'preCall.description',
    en: "Before you join, make sure you're in a comfortable and quiet space.",
    fr: 'Avant de participer, assurez-vous d’être dans un endroit confortable et calme.',
  },
  {
    id: 'preCall.cameraPreview',
    en: 'Camera preview',
    fr: 'Aperçu de la caméra',
  },
  {
    id: 'preCall.turnOff',
    en: 'Turn Off',
    fr: 'Désactiver',
  },
  {
    id: 'preCall.turnOn',
    en: 'Turn On',
    fr: 'Activer',
  },
  {
    id: 'preCall.camera.label',
    en: 'Camera',
    fr: 'Caméra',
  },
  {
    id: 'preCall.camera.ready',
    en: 'Camera is working properly',
    fr: 'La caméra fonctionne correctement',
  },
  {
    id: 'preCall.camera.requesting',
    en: 'Checking camera...',
    fr: 'Vérification de la caméra...',
  },
  {
    id: 'preCall.camera.missing',
    en: 'No camera found',
    fr: 'Aucune caméra trouvée',
  },
  {
    id: 'preCall.camera.blocked',
    en: 'Camera access is blocked',
    fr: 'L’accès à la caméra est bloqué',
  },
  {
    id: 'preCall.camera.failed',
    en: 'Camera is unavailable',
    fr: 'La caméra n’est pas disponible',
  },
  {
    id: 'preCall.microphone.label',
    en: 'Microphone',
    fr: 'Microphone',
  },
  {
    id: 'preCall.microphone.ready',
    en: 'Microphone is working properly',
    fr: 'Le microphone fonctionne correctement',
  },
  {
    id: 'preCall.microphone.requesting',
    en: 'Checking microphone...',
    fr: 'Vérification du microphone...',
  },
  {
    id: 'preCall.microphone.missing',
    en: 'No microphone found',
    fr: 'Aucun microphone trouvé',
  },
  {
    id: 'preCall.microphone.blocked',
    en: 'Microphone access is blocked',
    fr: 'L’accès au microphone est bloqué',
  },
  {
    id: 'preCall.microphone.failed',
    en: 'Microphone is unavailable',
    fr: 'Le microphone n’est pas disponible',
  },
  {
    id: 'preCall.microphoneAccessNeeded.title',
    en: 'Microphone access needed',
    fr: 'Accès au microphone requis',
  },
  {
    id: 'preCall.microphoneAccessNeeded.description',
    en: 'Go to your browser settings to allow access to your microphone.',
    fr: 'Accédez aux paramètres de votre navigateur pour autoriser l’accès à votre microphone.',
  },
  {
    id: 'preCall.speaker.label',
    en: 'Speaker',
    fr: 'Haut-parleur',
  },
  {
    id: 'preCall.speaker.unsupported',
    en: 'Speaker selection is not supported in this browser.',
    fr: 'La sélection du haut-parleur n’est pas prise en charge par ce navigateur.',
  },
  {
    id: 'preCall.speaker.playing',
    en: 'Playing test sound...',
    fr: 'Lecture du son de test...',
  },
  {
    id: 'preCall.speaker.help',
    en: 'Select a speaker and test the sound.',
    fr: 'Sélectionnez un haut-parleur et testez le son.',
  },
  {
    id: 'preCall.speaker.test',
    en: 'Play test sound',
    fr: 'Tester le son',
  },
  {
    id: 'preCall.technicalIssues.title',
    en: "If you're having technical issues",
    fr: 'Si vous éprouvez des difficultés techniques',
  },
  {
    id: 'preCall.technicalIssues.description',
    en: 'Dial {{tollFree}} and enter the PIN {{pin}} followed by the # key.',
    fr: 'Composez le {{tollFree}} et entrez le NIP {{pin}}, suivi de la touche #.',
  },
  {
    id: 'preCall.cancel',
    en: 'Cancel',
    fr: 'Annuler',
  },
  {
    id: 'preCall.join',
    en: 'Join Session',
    fr: 'Rejoindre la séance',
  },
  {
    id: 'Settings',
    en: 'Settings',
    fr: 'Paramètres',
  },
  {
    id: 'deviceSettings.joinTollFree.before',
    en: 'Alternatively, join via Toll-free number ',
    fr: 'Vous pouvez également vous connecter en utilisant le numéro sans frais ',
  },
  {
    id: 'deviceSettings.joinTollFree.after',
    en: ' and use pin {{pin}} followed by #',
    fr: ' et en composant le code NIP {{pin}} suivi du carré (#)',
  },
  {
    id: 'deviceSettings.camera.rejoin',
    en: 'Reconnect the session to start using a camera.',
    fr: 'Reconnectez la séance pour commencer à utiliser une caméra.',
  },
  {
    id: 'deviceSettings.camera.error',
    en: 'Unable to change camera. Your previous camera is still selected.',
    fr: 'Impossible de changer de caméra. La caméra précédente est toujours sélectionnée.',
  },
  {
    id: 'deviceSettings.camera.changing',
    en: 'Changing camera...',
    fr: 'Changement de caméra...',
  },
  {
    id: 'deviceSettings.microphone.error',
    en: 'Unable to change microphone. Your previous microphone is still selected.',
    fr: 'Impossible de changer de microphone. Le microphone précédent est toujours sélectionné.',
  },
  {
    id: 'deviceSettings.microphone.changing',
    en: 'Changing microphone...',
    fr: 'Changement de microphone...',
  },
  {
    id: 'deviceSettings.speaker.error',
    en: 'Unable to change speaker. Your previous speaker is still selected.',
    fr: 'Impossible de changer de haut-parleur. Le haut-parleur précédent est toujours sélectionné.',
  },
  {
    id: 'deviceSettings.speaker.changing',
    en: 'Changing speaker...',
    fr: 'Changement de haut-parleur...',
  },
];

export default localeMessage;
